import { useState } from "react";
import { Flex, Input, Button, SendIcon } from "@fluentui/react-northstar";
import { useChatStore } from "../../stores/useChatStore";

const InputArea = ({ onAskQuestion }) => {
    const [inputValue, setInputValue] = useState("");
    const { isTyping } = useChatStore();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (inputValue.trim() && !isTyping) {
            setInputValue("");
            onAskQuestion(inputValue);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <Flex
                gap="gap.small"
                vAlign="center"
                styles={{
                    padding: "16px",
                    borderTop: "1px solid #E1DFDD",
                    backgroundColor: "white",
                }}
            >
                <Input
                    fluid
                    placeholder="Tapez votre message..."
                    value={inputValue}
                    onChange={(e, data) => setInputValue(data.value)}
                    onKeyPress={handleKeyPress}
                    disabled={isTyping}
                />
                <Button
                    primary
                    icon={<SendIcon />}
                    iconOnly
                    disabled={!inputValue.trim() || isTyping}
                    onClick={handleSubmit}
                    aria-label="Send message"
                />
            </Flex>
        </form>
    );
};

export default InputArea;
